import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { ApiResponse, AdImageWithTag } from '@magnetar/admin-api-interfaces'

export type AdImage = AdImageWithTag

export interface AdImageBatchItem {
  item_id: number
  batch_id: number
  ad_image_id: number
  order: number
  created_at: string
  is_active: boolean
  ad_image: AdImage
}

export interface AdImageBatch {
  batch_id: number
  provider_id?: number | null
  batch_name: string
  description?: string
  overlay_interval_ms: number
  created_by?: number | null
  created_at: string
  updated_at: string
  is_active: boolean
  items: AdImageBatchItem[]
}

interface UseAdImageBatchesParams {
  includeInactive?: boolean
  providerId?: number
}

export function useAdImageBatches(params?: UseAdImageBatchesParams) {
  const { token } = useAuth()

  const queryParams = new URLSearchParams()
  if (params?.includeInactive) queryParams.set('includeInactive', 'true')
  if (params?.providerId) queryParams.set('providerId', String(params.providerId))
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : ''

  const { data, error, mutate } = useGet<ApiResponse<AdImageBatch[]>>(
    token ? `/api/ad-image-batches${queryString}` : null,
    undefined,
    token ?? '',
  )

  return {
    batches: data?.data || [],
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
